var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "nav-view" } },
    [
      _c("topNav", {
        attrs: {
          menuTree: _vm.isSwitch2WmsMenu ? _vm.wmsMenuTree : _vm.spmMenuTree,
        },
      }),
      _c(
        "div",
        {
          staticClass: "content-box",
          class: [
            _vm.isCollapseCom ? "sider-collapse" : "",
            !_vm.menuRouterIndex ? "home-page" : "",
            _vm.isCollapseAllSide ? "hide-side-all" : "",
          ],
        },
        [
          _vm.menuRouterIndex
            ? _c(
                "div",
                { staticClass: "content-left" },
                [
                  _c(
                    "el-scrollbar",
                    { attrs: { "wrap-class": { "scrollbar-wrapper": true } } },
                    [
                      [
                        _c(
                          "div",
                          { staticClass: "search-menus" },
                          [
                            _c("el-input", {
                              staticClass: "search-input",
                              attrs: {
                                placeholder: _vm.$t("quickEntranceEnterMenu"),
                                size: "small",
                                "prefix-icon": "el-icon-search",
                              },
                              on: { input: _vm.searchValueChange },
                              model: {
                                value: _vm.searchValue,
                                callback: function ($$v) {
                                  _vm.searchValue = $$v
                                },
                                expression: "searchValue",
                              },
                            }),
                            _c("quickEntrance", {
                              on: { comfirm: _vm.queryQuickAddedList },
                            }),
                          ],
                          1
                        ),
                        _vm.filterMenus.length === 0 &&
                        _vm.filterCommonMenus.length === 0
                          ? _c("div", [
                              _c("div", { staticClass: "empty-block" }, [
                                _c("div", { staticClass: "empty-icon" }),
                                _c("div", { staticClass: "empty-text" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("quickEntranceNoResult"))
                                  ),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.filterMenus.length > 0 ||
                        _vm.filterCommonMenus.length > 0
                          ? _c(
                              "div",
                              { staticClass: "common-menu" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "menu-title",
                                    class: { open: _vm.showCollect },
                                    on: {
                                      click: function ($event) {
                                        _vm.showCollect = !_vm.showCollect
                                      },
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "menu-title1" }, [
                                      _c("i", { staticClass: "enter-icon" }),
                                      _c("span", { staticClass: "title" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("quickEntranceCommonMenu")
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _c(
                                        "span",
                                        { staticClass: "selected-num" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.filterCommonMenus.length)
                                          ),
                                        ]
                                      ),
                                      _c("span", { staticClass: "total-num" }, [
                                        _vm._v("/10"),
                                      ]),
                                    ]),
                                    _c("i", {
                                      staticClass: "el-icon-arrow-down",
                                    }),
                                  ]
                                ),
                                _c("el-collapse-transition", [
                                  _c(
                                    "ul",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showCollect,
                                          expression: "showCollect",
                                        },
                                      ],
                                      staticClass: "selected-menu-list",
                                      staticStyle: {
                                        "transform-origin": "center top",
                                      },
                                    },
                                    _vm._l(
                                      _vm.filterCommonMenus,
                                      function (menu, index) {
                                        return _c(
                                          "li",
                                          {
                                            key: menu.path,
                                            staticClass: "list-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.moveToPath(menu)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "max-width": "134px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "ToolTips",
                                                  {
                                                    attrs: {
                                                      text: _vm.$t(
                                                        menu.translation
                                                      ),
                                                      effect: "dark",
                                                      placement: "top",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            menu.translation
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-star-on",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeSelectMenu(
                                                    index
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      _c(
                        "el-menu",
                        {
                          staticClass: "el-menu-vertical",
                          attrs: {
                            router: "",
                            "unique-opened": true,
                            collapse: false,
                            "default-active": _vm.$route.path,
                            "default-openeds": _vm.openeds,
                          },
                        },
                        [
                          _vm.isSwitch2WmsMenu
                            ? _c("LeftNavOfWms", {
                                attrs: { menuTree: _vm.subWmsMenuTree },
                              })
                            : _c("LeftNavOfSpm", {
                                attrs: { menuTree: _vm.filterMenus },
                              }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "new-menu-right-content" },
            [
              _c(
                "tags-view",
                {
                  attrs: {
                    menuLinkList: _vm.isSwitch2WmsMenu
                      ? _vm.wmsMenuLinkList
                      : _vm.spmMenuLinkList,
                  },
                },
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in" } },
                    [_c("router-view", { ref: "_contentView" })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("image-print-template"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }